enum Setting {
  disallowUnmute = 'DisallowUnmute',
  muteOnEntry = 'MuteOnEntry',
}

export default Setting;
